import {
  Component,
  HostListener,
  OnInit,
  inject,
} from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { MatInputModule } from '@angular/material/input';
import {
  MatDialog,
} from '@angular/material/dialog';
import { AgGridAngular } from 'ag-grid-angular';
import { ColDef } from 'ag-grid-community';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { ConfirmDialog } from '../../shared/components/confirm-dialog/confirm-dialog';
import { ToastrService } from 'ngx-toastr';
import { PettyCashService } from '../../features/petty-cash/services/petty-cash.service';
import { ModuleIds } from '../../shared/permission-constants/permission-const';
import { PermissionService } from '../../shared/services/permission.service';

@Component({
  selector: 'app-petty-cash',
  standalone: true,
  imports: [CommonModule, MatInputModule, AgGridAngular],
  templateUrl: './petty-cash.component.html',
  styleUrl: './petty-cash.component.scss',
})
export class PettyCashComponent implements OnInit {
  public viewPortSize: boolean = false;
  public rowData: any[] | null = null;
  public loading: boolean = true;
  public error: any = null;
  private searchSubject = new Subject<string>();
  readonly dialog = inject(MatDialog);
  columnDefs: any[] = [];

  public defaultColDef: ColDef = {
    filter: 'agTextColumnFilter',
    floatingFilter: true,
  };
  public rowSelection: 'single' | 'multiple' = 'multiple';
  public paginationPageSize = 10;
  public paginationPageSizeSelector: number[] | boolean = [10, 25, 50];
  public themeClass: string = 'ag-theme-quartz';
  profileName: any;
  canCreatePettyCash$ = this.permissionService.hasPermission(
      ModuleIds.PettyCash,
      'Create'
    );


  constructor(
    private router: Router,
    private pettyCashService: PettyCashService,
    private toastr: ToastrService,
    private datePipe: DatePipe,
    private permissionService: PermissionService
  ) {
    const loggedInUser: any = localStorage.getItem('loggedInUser');
    const userData = JSON.parse(loggedInUser);
    this.profileName = userData?.profileData?.profileName;
  }

  ngOnInit(): void {
    this.fetchItems();
    this.searchSubject.subscribe((searchTerm) => {
      this.fetchItems(searchTerm);
    });

    this.checkViewportSize();
  }

  checkViewportSize() {
    if (window.innerWidth > 1200) {
      this.viewPortSize = true;
    } else {
      this.viewPortSize = false;
    }
    this.updateColumnDefs();
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.checkViewportSize();
  }

  updateColumnDefs(): void {
    this.columnDefs = [
      {
        headerName: 'Employee Name',
        field: 'employeeName',
        flex: this.viewPortSize ? 1 : 0,
      },
      { headerName: 'Date', field: 'date', flex: this.viewPortSize ? 1 : 0 },
      {
        headerName: 'Petty Cash No',
        field: 'pettyCashNo',
        flex: this.viewPortSize ? 1 : 0,
      },
      {
        headerName: 'Opening Balance',
        field: 'openingBalance',
        flex: this.viewPortSize ? 1 : 0,
      },
      {
        headerName: 'Current Balance',
        field: 'currentBalance',
        flex: this.viewPortSize ? 1 : 0,
      },
    ];
  }

  onSearch(event: Event) {
    const input = event.target as HTMLInputElement;
    const searchTerm = input.value;
    this.searchSubject.next(searchTerm);
  }

  fetchItems(search: string = '') {
    this.loading = true;
    this.pettyCashService.fetchPettyCashAccounts(search, true).subscribe({
      next: (items) => {
        this.rowData = items.map((item: any) => ({
          id: item?.id,
          pettyCashNo: item?.pettyCashNumber || '--',
          openingBalance: item?.openingBalance
            ? `${item?.currencyData?.currencyCode} ${item?.openingBalance.toFixed(2)}`
            : '--',
          currentBalance: item?.currentBalance
            ? `${item?.currencyData?.currencyCode} ${item?.currentBalance.toFixed(2)}`
            : '--',
          date: this.datePipe.transform(item?.createdAt, 'dd/MM/YYYY') || '',
          employeeId: item?.employeeId,
          employeeName: item?.employeeData?.firstName+ ' ' + item?.employeeData?.lastName
        }));

        this.loading = false;
      },
      error: (error) => {
        this.error = error;
        this.loading = false;
      },
    });
  }


  addPettyCash(){
    this.router.navigate(['petty-cash/add-petty-cash']);
  }

  onDeleteItem(itemData: any): void {
    const dialogRef = this.dialog.open(ConfirmDialog);

    dialogRef.afterClosed().subscribe((result) => {
      if (result === true) {
        this.removeItem(itemData?.id);
      }
    });
  }

  private removeItem(itemId: number): void {
    this.pettyCashService.removePettyCash(itemId).subscribe({
      next: () => {
        this.toastr.success('Petty cash removed successfully.');
        this.fetchItems();
      },
      error: (error) => {
        console.log('ERROR', error);
        this.toastr.error(
          error?.message || 'Failed to petty cash. Please try again.'
        );
      },
    });
  }

  onCellClicked(params: any) {
    if (
      params.column.colId === 'action' &&
      params.event.target.dataset.action
    ) {
      let action = params.event.target.dataset.action;

      if (action === 'edit') {
        console.log("EDIT Function");
        
      } else if (action === 'delete') {
        this.onDeleteItem(params?.data);
      }
    } else {
      this.router.navigate(['petty-cash/petty-cash-details'], {
        queryParams: { pettyCashId: params?.data?.id, employeeId: params?.data?.employeeId },
      });
    }
  }

  navigateToAddNew() {
    this.router.navigate(['/petty-cash/add-petty-cash']);
  }
}
